(function (root, factory) {
  "use strict";
  var api = factory();
  if (typeof module === "object" && module.exports) module.exports = api;
  if (root) root.TK9NativeCartCore = api;
})(typeof globalThis !== "undefined" ? globalThis : this, function () {
  "use strict";

  var VERSION = "2026-08-09-native-page-v1";
  var CHECKOUT_PATH = "/checkout";
  var ALLOWED_ACTIONS = { add: true, change_variant: true, link: true };
  var BLOCKED_KEY = /(script|javascript|checkout.?url|redirect.?url|destination|onload|onclick|onerror|srcdoc|innerhtml|eval|function)/i;
  var SAFE_COLOR_KEYS = {
    "pink-camo": true,
    multicam: true,
    lavender: true,
    orange: true,
    green: true,
    brown: true,
    black: true,
    gray: true,
    beige: true
  };
  var SAFE_SIZE_KEYS = {
    "extra-small": true,
    small: true,
    medium: true,
    large: true,
    "extra-large": true
  };

  var TOP_LEVEL_KEYS = allow([
    "version", "cart", "cartDisplay", "includedPerks", "offerGroups",
    "orderDataSource", "productIds", "protection"
  ]);
  var CART_KEYS = allow([
    "freeShippingThresholdCents", "discountSafeThresholds", "maxOffers",
    "discountBasis", "storeReviewProof", "buyerProof", "routingPolicy",
    "checkoutVerifiedHarnessFallbackEnabled"
  ]);
  var ROUTING_KEYS = allow([
    "version", "catalogProductCount", "familyByProductId",
    "intentionalFallbackProductIds", "excludedInternalProductIds", "rule"
  ]);
  var CART_DISPLAY_KEYS = allow([
    "productNames", "optionValueNames", "bundleCompareAtVariantMap",
    "compareAtVariantMap"
  ]);
  var GROUP_KEYS = allow([
    "id", "title", "subtitle", "priority", "reviewProof", "defaultFallback",
    "triggerProductIds", "suppressIfProductInCart", "includedPerkKey", "offers"
  ]);
  var OFFER_KEYS = allow([
    "id", "productId", "title", "copy", "priceCents", "standalonePriceCents",
    "tag", "badge", "includesLabel", "includes", "displayIncludes", "image",
    "action", "buttonLabel", "suppressIfProductInCart",
    "suppressIfProductIdsPresent", "suppressIfCartContainsText",
    "requireProductInCart", "requiresProperties", "sizeVariantMap", "variantMap",
    "variantMatchModeMap", "imageMap", "imageVariantMap", "priceVariantMap",
    "standalonePriceVariantMap", "fallbackVariantId", "variantId", "targetVariantId",
    "targetVariantMap", "sourceVariantIds", "minSourceQuantity", "maxSourceQuantity",
    "targetQuantityDivisor", "tier", "perTriggerLineOffer", "triggerCoverageText",
    "valueCue", "productUrl", "requireMatchedVariant", "variantChoices",
    "variantChoiceLabel", "componentId", "componentIds"
  ]);
  var PROPERTY_KEYS = allow([
    "name", "label", "required", "maxLength", "type", "autocomplete",
    "autocapitalize", "placeholder"
  ]);
  var VARIANT_CHOICE_KEYS = allow([
    "label", "variantId", "image", "priceCents", "standalonePriceCents"
  ]);
  var PROTECTION_KEYS = allow([
    "id", "productId", "variantId", "title", "copy", "priceCents", "image"
  ]);
  var PERK_KEYS = allow(["title", "meta", "claim", "summary", "items"]);
  var PERK_ITEM_KEYS = allow(["label", "image", "value", "copy"]);
  var DISCOUNT_THRESHOLD_KEYS = allow(["code", "rate"]);

  function allow(keys) {
    var result = Object.create(null);
    keys.forEach(function (key) { result[key] = true; });
    return result;
  }

  function isPlainObject(value) {
    return Boolean(value) && typeof value === "object" && !Array.isArray(value) && Object.prototype.toString.call(value) === "[object Object]";
  }

  function ownKeys(value) {
    return isPlainObject(value) ? Object.keys(value) : [];
  }

  function rejectPrototypeKeys(value, path, errors) {
    if (!value || typeof value !== "object") return;
    if (Array.isArray(value)) {
      value.forEach(function (item, index) {
        rejectPrototypeKeys(item, path + "[" + index + "]", errors);
      });
      return;
    }
    ownKeys(value).forEach(function (key) {
      if (key === "__proto__" || key === "prototype" || key === "constructor") {
        errors.push(path + "." + key + " is not allowed");
        return;
      }
      rejectPrototypeKeys(value[key], path + "." + key, errors);
    });
  }

  function validateKeys(value, allowed, path, errors) {
    if (!isPlainObject(value)) {
      errors.push(path + " must be an object");
      return;
    }
    ownKeys(value).forEach(function (key) {
      if (!allowed[key]) errors.push(path + "." + key + " is not an allowed field");
      if (BLOCKED_KEY.test(key)) errors.push(path + "." + key + " is executable or redirect-capable configuration");
    });
  }

  function safeInteger(value) {
    var number = Number(value);
    return Number.isSafeInteger(number) && number > 0;
  }

  function nonNegativeInteger(value) {
    var number = Number(value);
    return Number.isSafeInteger(number) && number >= 0;
  }

  function validateShortString(value, path, errors, maxLength, required) {
    if (typeof value !== "string" || value.length > Number(maxLength || 300) || required && !value.trim()) {
      errors.push(path + " must be " + (required ? "a non-empty " : "a ") + "short string");
    }
  }

  function validateBoolean(value, path, errors) {
    if (typeof value !== "boolean") errors.push(path + " must be a boolean");
  }

  function validatePositiveInteger(value, path, errors) {
    if (!safeInteger(value)) errors.push(path + " must be a positive integer");
  }

  function validateMoney(value, path, errors) {
    if (!nonNegativeInteger(value)) errors.push(path + " must be a non-negative integer number of cents");
  }

  function validateIdArray(value, path, errors) {
    if (!Array.isArray(value)) {
      errors.push(path + " must be an array");
      return;
    }
    if (value.length > 500) errors.push(path + " exceeds the allowed length");
    value.forEach(function (id, index) {
      if (!safeInteger(id)) errors.push(path + "[" + index + "] must be a positive integer");
    });
  }

  function validateStringMap(value, path, errors, options) {
    options = options || {};
    if (!isPlainObject(value)) {
      errors.push(path + " must be an object");
      return;
    }
    var keys = ownKeys(value);
    if (keys.length > Number(options.maxEntries || 1000)) errors.push(path + " exceeds the allowed number of entries");
    keys.forEach(function (key) {
      if (BLOCKED_KEY.test(key)) errors.push(path + "." + key + " is executable or redirect-capable configuration");
      if (key.length > Number(options.maxKeyLength || 120) || options.keyPattern && !options.keyPattern.test(key)) {
        errors.push(path + "." + key + " has an invalid key");
      }
      validateShortString(value[key], path + "." + key, errors, options.maxValueLength || 300, !options.allowEmpty);
    });
  }

  function validateIdMap(value, path, errors, keyPattern, maxEntries) {
    if (!isPlainObject(value)) {
      errors.push(path + " must be an object");
      return;
    }
    var keys = ownKeys(value);
    if (keys.length > Number(maxEntries || 1000)) errors.push(path + " exceeds the allowed number of entries");
    keys.forEach(function (key) {
      if (BLOCKED_KEY.test(key)) errors.push(path + "." + key + " is executable or redirect-capable configuration");
      if (keyPattern && !keyPattern.test(key)) errors.push(path + "." + key + " has an invalid key");
      validatePositiveInteger(value[key], path + "." + key, errors);
    });
  }

  function validateMoneyMap(value, path, errors) {
    if (!isPlainObject(value)) {
      errors.push(path + " must be an object");
      return;
    }
    var keys = ownKeys(value);
    if (keys.length > 2000) errors.push(path + " exceeds the allowed number of entries");
    keys.forEach(function (key) {
      if (BLOCKED_KEY.test(key)) errors.push(path + "." + key + " is executable or redirect-capable configuration");
      if (!/^\d{6,20}$/.test(key)) errors.push(path + "." + key + " is not a variant id");
      validateMoney(value[key], path + "." + key, errors);
    });
  }

  function validateStringArray(value, path, errors, max) {
    if (!Array.isArray(value)) {
      errors.push(path + " must be an array");
      return;
    }
    if (value.length > Number(max || 100)) errors.push(path + " exceeds the allowed length");
    value.forEach(function (entry, index) {
      if (typeof entry !== "string" || entry.length > 300) errors.push(path + "[" + index + "] must be a short string");
    });
  }

  function validateNumericMap(value, path, errors, allowedKeys) {
    if (!isPlainObject(value)) {
      errors.push(path + " must be an object");
      return;
    }
    ownKeys(value).forEach(function (key) {
      if (allowedKeys && !allowedKeys[key]) errors.push(path + "." + key + " is not an allowed selector");
      var entry = value[key];
      if (isPlainObject(entry)) {
        validateNumericMap(entry, path + "." + key, errors, SAFE_COLOR_KEYS);
      } else if (!safeInteger(entry)) {
        errors.push(path + "." + key + " must be a positive variant id");
      }
    });
  }

  function safeAssetReference(value) {
    var text = String(value || "").trim();
    if (!text) return true;
    if (/^[A-Za-z0-9][A-Za-z0-9._?=&%+-]*$/.test(text)) return true;
    if (/^\/\/(cdn\.shopify\.com|teamk9\.com)\//i.test(text)) return true;
    if (/^https:\/\/(cdn\.shopify\.com|teamk9\.com)(\/|$)/i.test(text)) return true;
    if (/^\/cdn\/shop\//i.test(text)) return true;
    return false;
  }

  function safeProductPath(value) {
    var text = String(value || "").trim();
    return !text || /^\/products\/[A-Za-z0-9][A-Za-z0-9-]*(?:[?#][^\s]*)?$/.test(text);
  }

  function validateOffer(offer, path, errors) {
    validateKeys(offer, OFFER_KEYS, path, errors);
    if (!offer.id || typeof offer.id !== "string" || !/^[a-z0-9][a-z0-9-]{0,79}$/.test(offer.id)) {
      errors.push(path + ".id must be a kebab-case identifier");
    }
    if (!ALLOWED_ACTIONS[String(offer.action || "")]) errors.push(path + ".action is not allowed");
    if (offer.productId !== undefined) validatePositiveInteger(offer.productId, path + ".productId", errors);
    if (offer.productUrl !== undefined && !safeProductPath(offer.productUrl)) errors.push(path + ".productUrl must be a same-origin /products path");
    if (offer.image !== undefined && !safeAssetReference(offer.image)) errors.push(path + ".image must be a Team K9 or Shopify asset");
    ["title", "copy", "tag", "badge", "includesLabel", "buttonLabel", "valueCue", "variantChoiceLabel"].forEach(function (key) {
      if (offer[key] !== undefined) validateShortString(offer[key], path + "." + key, errors, key === "copy" ? 700 : 180, false);
    });
    ["priceCents", "standalonePriceCents"].forEach(function (key) {
      if (offer[key] !== undefined) validateMoney(offer[key], path + "." + key, errors);
    });
    ["fallbackVariantId", "variantId", "targetVariantId", "componentId", "minSourceQuantity", "maxSourceQuantity", "targetQuantityDivisor"].forEach(function (key) {
      if (offer[key] !== undefined) validatePositiveInteger(offer[key], path + "." + key, errors);
    });
    ["requireMatchedVariant", "perTriggerLineOffer"].forEach(function (key) {
      if (offer[key] !== undefined) validateBoolean(offer[key], path + "." + key, errors);
    });
    if (offer.tier !== undefined && !/^[a-z0-9][a-z0-9_-]{0,39}$/i.test(String(offer.tier))) errors.push(path + ".tier is invalid");
    ["suppressIfProductInCart", "suppressIfProductIdsPresent", "requireProductInCart", "sourceVariantIds", "componentIds"].forEach(function (key) {
      if (key !== "suppressIfProductInCart" && offer[key] !== undefined) validateIdArray(offer[key], path + "." + key, errors);
    });
    if (offer.suppressIfProductInCart !== undefined && typeof offer.suppressIfProductInCart !== "boolean") validateIdArray(offer.suppressIfProductInCart, path + ".suppressIfProductInCart", errors);
    ["suppressIfCartContainsText", "triggerCoverageText", "includes", "displayIncludes"].forEach(function (key) {
      if (offer[key] !== undefined) validateStringArray(offer[key], path + "." + key, errors, 100);
    });
    if (offer.sizeVariantMap !== undefined) validateNumericMap(offer.sizeVariantMap, path + ".sizeVariantMap", errors, SAFE_SIZE_KEYS);
    if (offer.variantMap !== undefined) validateNumericMap(offer.variantMap, path + ".variantMap", errors, SAFE_COLOR_KEYS);
    ["imageMap", "variantMatchModeMap"].forEach(function (key) {
      if (offer[key] === undefined) return;
      if (!isPlainObject(offer[key])) {
        errors.push(path + "." + key + " must be an object");
        return;
      }
      ownKeys(offer[key]).forEach(function (mapKey) {
        if (!SAFE_COLOR_KEYS[mapKey]) errors.push(path + "." + key + "." + mapKey + " is not an allowed color");
        if (key === "imageMap" && !safeAssetReference(offer[key][mapKey])) errors.push(path + ".imageMap contains an unsafe asset");
        if (key === "variantMatchModeMap" && !/^(exact|disclosed_[a-z0-9_]+)$/.test(String(offer[key][mapKey] || ""))) errors.push(path + ".variantMatchModeMap contains an unsafe mode");
      });
    });
    ["imageVariantMap", "priceVariantMap", "standalonePriceVariantMap", "targetVariantMap"].forEach(function (key) {
      if (offer[key] === undefined) return;
      if (!isPlainObject(offer[key])) {
        errors.push(path + "." + key + " must be an object");
        return;
      }
      ownKeys(offer[key]).forEach(function (variantKey) {
        if (!safeInteger(variantKey)) errors.push(path + "." + key + " has an invalid variant key");
        if (key === "imageVariantMap" && !safeAssetReference(offer[key][variantKey])) errors.push(path + ".imageVariantMap contains an unsafe asset");
        if (key !== "imageVariantMap" && !safeInteger(offer[key][variantKey])) errors.push(path + "." + key + " must contain positive integers");
      });
    });
    if (offer.requiresProperties !== undefined) {
      if (!Array.isArray(offer.requiresProperties) || offer.requiresProperties.length > 4) {
        errors.push(path + ".requiresProperties must contain at most four fields");
      } else {
        offer.requiresProperties.forEach(function (field, index) {
          var fieldPath = path + ".requiresProperties[" + index + "]";
          validateKeys(field, PROPERTY_KEYS, fieldPath, errors);
          if (!field.name || typeof field.name !== "string" || field.name.length > 100) errors.push(fieldPath + ".name is invalid");
          ["label", "placeholder"].forEach(function (key) {
            if (field[key] !== undefined) validateShortString(field[key], fieldPath + "." + key, errors, 120, key === "label");
          });
          if (field.required !== undefined) validateBoolean(field.required, fieldPath + ".required", errors);
          if (field.type && field.type !== "text") errors.push(fieldPath + ".type must be text");
          if (Number(field.maxLength || 0) < 1 || Number(field.maxLength || 0) > 80) errors.push(fieldPath + ".maxLength is invalid");
          if (field.autocomplete !== undefined && !/^(off|name|tel)$/.test(String(field.autocomplete))) errors.push(fieldPath + ".autocomplete is invalid");
          if (field.autocapitalize !== undefined && !/^(off|none|on|sentences|words|characters)$/.test(String(field.autocapitalize))) errors.push(fieldPath + ".autocapitalize is invalid");
        });
      }
    }
    if (offer.variantChoices !== undefined) {
      if (!Array.isArray(offer.variantChoices) || offer.variantChoices.length > 30) {
        errors.push(path + ".variantChoices must contain at most 30 choices");
      } else {
        offer.variantChoices.forEach(function (choice, index) {
          var choicePath = path + ".variantChoices[" + index + "]";
          validateKeys(choice, VARIANT_CHOICE_KEYS, choicePath, errors);
          if (!safeInteger(choice.variantId)) errors.push(choicePath + ".variantId is invalid");
          if (!safeAssetReference(choice.image)) errors.push(choicePath + ".image is unsafe");
          if (choice.label !== undefined) validateShortString(choice.label, choicePath + ".label", errors, 180, true);
          if (choice.priceCents !== undefined) validateMoney(choice.priceCents, choicePath + ".priceCents", errors);
          if (choice.standalonePriceCents !== undefined) validateMoney(choice.standalonePriceCents, choicePath + ".standalonePriceCents", errors);
        });
      }
    }
  }

  function validateRules(rules) {
    var errors = [];
    if (!isPlainObject(rules)) return { ok: false, errors: ["rules must be an object"] };
    rejectPrototypeKeys(rules, "rules", errors);
    validateKeys(rules, TOP_LEVEL_KEYS, "rules", errors);
    validateShortString(rules.version, "rules.version", errors, 120, true);
    if (rules.orderDataSource !== undefined) validateShortString(rules.orderDataSource, "rules.orderDataSource", errors, 500, true);
    if (rules.cart !== undefined) {
      validateKeys(rules.cart, CART_KEYS, "rules.cart", errors);
      if (rules.cart.freeShippingThresholdCents !== undefined) validateMoney(rules.cart.freeShippingThresholdCents, "rules.cart.freeShippingThresholdCents", errors);
      if (rules.cart.maxOffers !== undefined && (!safeInteger(rules.cart.maxOffers) || Number(rules.cart.maxOffers) > 20)) errors.push("rules.cart.maxOffers must be between 1 and 20");
      if (rules.cart.discountBasis !== undefined && rules.cart.discountBasis !== "cart_total_price") errors.push("rules.cart.discountBasis is not allowed");
      ["storeReviewProof", "buyerProof"].forEach(function (key) {
        if (rules.cart[key] !== undefined) validateShortString(rules.cart[key], "rules.cart." + key, errors, 180, true);
      });
      if (rules.cart.checkoutVerifiedHarnessFallbackEnabled !== undefined) validateBoolean(rules.cart.checkoutVerifiedHarnessFallbackEnabled, "rules.cart.checkoutVerifiedHarnessFallbackEnabled", errors);
      if (rules.cart.discountSafeThresholds !== undefined) {
        if (!Array.isArray(rules.cart.discountSafeThresholds) || rules.cart.discountSafeThresholds.length > 20) errors.push("rules.cart.discountSafeThresholds must contain at most 20 entries");
        else rules.cart.discountSafeThresholds.forEach(function (entry, index) {
          var entryPath = "rules.cart.discountSafeThresholds[" + index + "]";
          validateKeys(entry, DISCOUNT_THRESHOLD_KEYS, entryPath, errors);
          if (!/^[A-Za-z0-9_-]{1,60}$/.test(String(entry && entry.code || ""))) errors.push(entryPath + ".code is invalid");
          if (!Number.isFinite(Number(entry && entry.rate)) || Number(entry.rate) <= 0 || Number(entry.rate) >= 1) errors.push(entryPath + ".rate must be between 0 and 1");
        });
      }
      if (rules.cart.routingPolicy !== undefined) {
        var routing = rules.cart.routingPolicy;
        validateKeys(routing, ROUTING_KEYS, "rules.cart.routingPolicy", errors);
        if (routing.version !== undefined) validateShortString(routing.version, "rules.cart.routingPolicy.version", errors, 120, true);
        if (routing.catalogProductCount !== undefined) validatePositiveInteger(routing.catalogProductCount, "rules.cart.routingPolicy.catalogProductCount", errors);
        if (routing.familyByProductId !== undefined) validateStringMap(routing.familyByProductId, "rules.cart.routingPolicy.familyByProductId", errors, { keyPattern: /^\d{6,20}$/, maxEntries: 500, maxValueLength: 80 });
        if (routing.intentionalFallbackProductIds !== undefined) validateIdArray(routing.intentionalFallbackProductIds, "rules.cart.routingPolicy.intentionalFallbackProductIds", errors);
        if (routing.excludedInternalProductIds !== undefined) validateIdArray(routing.excludedInternalProductIds, "rules.cart.routingPolicy.excludedInternalProductIds", errors);
        if (routing.rule !== undefined) validateShortString(routing.rule, "rules.cart.routingPolicy.rule", errors, 700, true);
      }
    }
    if (rules.cartDisplay !== undefined) {
      validateKeys(rules.cartDisplay, CART_DISPLAY_KEYS, "rules.cartDisplay", errors);
      if (rules.cartDisplay.productNames !== undefined) validateStringMap(rules.cartDisplay.productNames, "rules.cartDisplay.productNames", errors, { keyPattern: /^\d{6,20}$/, maxEntries: 500, maxValueLength: 180 });
      if (rules.cartDisplay.optionValueNames !== undefined) validateStringMap(rules.cartDisplay.optionValueNames, "rules.cartDisplay.optionValueNames", errors, { maxEntries: 500, maxKeyLength: 160, maxValueLength: 180, allowEmpty: true });
      if (rules.cartDisplay.bundleCompareAtVariantMap !== undefined) validateMoneyMap(rules.cartDisplay.bundleCompareAtVariantMap, "rules.cartDisplay.bundleCompareAtVariantMap", errors);
      if (rules.cartDisplay.compareAtVariantMap !== undefined) validateMoneyMap(rules.cartDisplay.compareAtVariantMap, "rules.cartDisplay.compareAtVariantMap", errors);
    }
    if (rules.productIds !== undefined) validateIdMap(rules.productIds, "rules.productIds", errors, /^[a-z][A-Za-z0-9]{0,79}$/, 200);
    if (rules.includedPerks !== undefined) {
      if (!isPlainObject(rules.includedPerks)) errors.push("rules.includedPerks must be an object");
      else ownKeys(rules.includedPerks).forEach(function (key) {
        var perk = rules.includedPerks[key];
        var perkPath = "rules.includedPerks." + key;
        if (!/^[a-z0-9][a-z0-9-]{0,79}$/.test(key)) errors.push(perkPath + " has an invalid key");
        validateKeys(perk, PERK_KEYS, perkPath, errors);
        ["title", "meta", "claim", "summary"].forEach(function (field) {
          if (perk[field] !== undefined) validateShortString(perk[field], perkPath + "." + field, errors, field === "summary" ? 700 : 180, true);
        });
        if (!Array.isArray(perk.items) || perk.items.length > 12) errors.push(perkPath + ".items must contain at most 12 entries");
        else perk.items.forEach(function (item, index) {
          validateKeys(item, PERK_ITEM_KEYS, perkPath + ".items[" + index + "]", errors);
          if (!safeAssetReference(item.image)) errors.push(perkPath + ".items[" + index + "].image is unsafe");
          ["label", "value", "copy"].forEach(function (field) {
            if (item[field] !== undefined) validateShortString(item[field], perkPath + ".items[" + index + "]." + field, errors, 300, true);
          });
        });
      });
    }
    if (!Array.isArray(rules.offerGroups) || !rules.offerGroups.length || rules.offerGroups.length > 20) {
      errors.push("rules.offerGroups must contain 1 to 20 groups");
    } else {
      var groupIds = Object.create(null);
      rules.offerGroups.forEach(function (group, groupIndex) {
        var groupPath = "rules.offerGroups[" + groupIndex + "]";
        validateKeys(group, GROUP_KEYS, groupPath, errors);
        if (!group.id || !/^[a-z0-9][a-z0-9-]{0,79}$/.test(group.id) || groupIds[group.id]) errors.push(groupPath + ".id is invalid or duplicated");
        groupIds[group.id] = true;
        validateIdArray(group.triggerProductIds || [], groupPath + ".triggerProductIds", errors);
        if (group.suppressIfProductInCart !== undefined) validateIdArray(group.suppressIfProductInCart, groupPath + ".suppressIfProductInCart", errors);
        ["title", "subtitle", "reviewProof", "includedPerkKey"].forEach(function (key) {
          if (group[key] !== undefined) validateShortString(group[key], groupPath + "." + key, errors, key === "subtitle" ? 500 : 180, true);
        });
        if (group.priority !== undefined) validatePositiveInteger(group.priority, groupPath + ".priority", errors);
        if (group.defaultFallback !== undefined) validateBoolean(group.defaultFallback, groupPath + ".defaultFallback", errors);
        if (!Array.isArray(group.offers) || group.offers.length > 40) errors.push(groupPath + ".offers must contain at most 40 offers");
        else group.offers.forEach(function (offer, offerIndex) { validateOffer(offer, groupPath + ".offers[" + offerIndex + "]", errors); });
      });
      if (rules.cart && rules.cart.routingPolicy && isPlainObject(rules.cart.routingPolicy.familyByProductId)) {
        ownKeys(rules.cart.routingPolicy.familyByProductId).forEach(function (productId) {
          var groupId = rules.cart.routingPolicy.familyByProductId[productId];
          if (!groupIds[groupId]) errors.push("rules.cart.routingPolicy.familyByProductId." + productId + " references an unknown group");
        });
      }
    }
    if (rules.protection !== undefined) {
      if (!Array.isArray(rules.protection) || rules.protection.length > 10) errors.push("rules.protection must contain at most 10 products");
      else rules.protection.forEach(function (item, index) {
        var itemPath = "rules.protection[" + index + "]";
        validateKeys(item, PROTECTION_KEYS, itemPath, errors);
        if (!safeInteger(item.productId) || !safeInteger(item.variantId)) errors.push(itemPath + " has invalid ids");
        if (!safeAssetReference(item.image)) errors.push(itemPath + ".image is unsafe");
        if (!/^[a-z0-9][a-z0-9-]{0,79}$/.test(String(item.id || ""))) errors.push(itemPath + ".id is invalid");
        ["title", "copy"].forEach(function (key) {
          if (item[key] !== undefined) validateShortString(item[key], itemPath + "." + key, errors, key === "copy" ? 500 : 180, true);
        });
        if (item.priceCents !== undefined) validateMoney(item.priceCents, itemPath + ".priceCents", errors);
      });
    }
    return { ok: errors.length === 0, errors: errors };
  }

  function assertValidRules(rules) {
    var result = validateRules(rules);
    if (!result.ok) {
      var error = new Error("Unsafe Team K9 cart rules: " + result.errors.slice(0, 8).join("; "));
      error.code = "TK9_UNSAFE_RULES";
      error.errors = result.errors;
      throw error;
    }
    return rules;
  }

  function absoluteUrl(value, base) {
    try { return new URL(String(value || ""), base || "https://teamk9.com"); } catch (error) { return null; }
  }

  function sameOriginPath(value, base, allowedPath) {
    var url = absoluteUrl(value, base);
    var origin = absoluteUrl(base, base);
    if (!url || !origin || url.origin !== origin.origin) return "";
    if (allowedPath && !allowedPath.test(url.pathname)) return "";
    return url.pathname + url.search;
  }

  function safeReadAssetUrl(value, base) {
    var url = absoluteUrl(value, base);
    var origin = absoluteUrl(base, base);
    if (!url || url.protocol !== "https:") return "";
    if (origin && url.origin === origin.origin) return url.toString();
    if (url.hostname === "cdn.shopify.com" || /\.myshopify\.com$/i.test(url.hostname)) return url.toString();
    return "";
  }

  function safeDisplayImageUrl(value, base, assetBase) {
    var raw = String(value || "").trim();
    if (!raw) return "";
    var candidate = /^[A-Za-z0-9][A-Za-z0-9._?=&%+-]*$/.test(raw)
      ? String(assetBase || "") + raw
      : raw.indexOf("//") === 0
        ? "https:" + raw
        : raw;
    var url = absoluteUrl(candidate, base);
    var origin = absoluteUrl(base, base);
    if (!url || !origin || url.protocol !== "https:") return "";
    if (url.origin === origin.origin) return url.toString();
    if (url.hostname === "cdn.shopify.com" || /\.myshopify\.com$/i.test(url.hostname) || /^(?:www\.)?teamk9\.com$/i.test(url.hostname)) return url.toString();
    return "";
  }

  function hardenRuntimeConfig(config, base) {
    if (!isPlainObject(config)) throw new Error("Cart runtime config is missing");
    var allowedConfigKeys = allow([
      "cartUrl", "clearUrl", "addUrl", "changeUrl", "checkoutUrl", "rulesUrl",
      "pricesUrl", "assetBaseUrl", "experimentId", "variantId", "surface", "engineVersion"
    ]);
    ownKeys(config).forEach(function (key) {
      if (!allowedConfigKeys[key] || BLOCKED_KEY.test(key) && key !== "checkoutUrl") throw new Error("Unsafe cart runtime field: " + key);
    });
    var hardened = Object.assign({}, config);
    hardened.cartUrl = sameOriginPath(config.cartUrl, base, /^\/cart(?:\.js)?$/);
    hardened.clearUrl = sameOriginPath(config.clearUrl, base, /^\/cart\/clear\.js$/);
    hardened.addUrl = sameOriginPath(config.addUrl, base, /^\/cart\/add\.js$/);
    hardened.changeUrl = sameOriginPath(config.changeUrl, base, /^\/cart\/change\.js$/);
    hardened.checkoutUrl = CHECKOUT_PATH;
    hardened.rulesUrl = safeReadAssetUrl(config.rulesUrl, base);
    hardened.pricesUrl = safeReadAssetUrl(config.pricesUrl, base);
    hardened.assetBaseUrl = config.assetBaseUrl ? safeReadAssetUrl(config.assetBaseUrl, base) : "";
    if (!hardened.cartUrl || !hardened.clearUrl || !hardened.addUrl || !hardened.changeUrl || !hardened.rulesUrl || !hardened.pricesUrl) {
      throw new Error("Cart runtime URLs failed the same-origin/Shopify asset policy");
    }
    return hardened;
  }

  function normalize(value) {
    return String(value || "").toLowerCase().replace(/[^a-z0-9]+/g, " ").trim();
  }

  function lineText(line) {
    var properties = line && line.properties && typeof line.properties === "object"
      ? ownKeys(line.properties).map(function (key) { return key + " " + line.properties[key]; }).join(" ")
      : "";
    var options = Array.isArray(line && line.options_with_values)
      ? line.options_with_values.map(function (item) { return item && item.value || ""; }).join(" ")
      : "";
    return [line && line.title, line && line.product_title, line && line.variant_title, options, properties].join(" ");
  }

  function detectColor(line) {
    var text = normalize(lineText(line));
    var colors = [
      ["pink-camo", ["pink camo"]],
      ["multicam", ["multicam", "multi cam", "camouflage"]],
      ["lavender", ["lavender", "purple"]],
      ["orange", ["orange", "blaze"]],
      ["black", ["black", "k9 black"]],
      ["brown", ["brown", "desert", "coyote"]],
      ["green", ["green", "olive", "od green"]],
      ["gray", ["gray", "grey"]],
      ["beige", ["beige", "tan"]]
    ];
    for (var index = 0; index < colors.length; index += 1) {
      if (colors[index][1].some(function (term) { return text.indexOf(term) !== -1; })) return colors[index][0];
    }
    return "";
  }

  function detectSize(line) {
    var text = normalize(lineText(line));
    if (/\b(extra large|x large|xl|bigger trucks|fits bigger)\b/.test(text)) return "extra-large";
    if (/\b(extra small|x small|xs)\b/.test(text)) return "extra-small";
    if (/\b(large|size l)\b/.test(text)) return "large";
    if (/\b(medium|size m)\b/.test(text)) return "medium";
    if (/\b(small|size s)\b/.test(text)) return "small";
    return "";
  }

  function variantId(line) {
    return Number(line && (line.variant_id || line.id) || 0);
  }

  function cartProductIds(cart) {
    var ids = Object.create(null);
    (cart && cart.items || []).forEach(function (line) { ids[String(line.product_id)] = true; });
    return ids;
  }

  function cartVariantIds(cart) {
    var ids = Object.create(null);
    (cart && cart.items || []).forEach(function (line) { ids[String(variantId(line))] = true; });
    return ids;
  }

  function containsAnyText(haystack, needles) {
    var text = normalize(haystack);
    return (needles || []).some(function (needle) { return text.indexOf(normalize(needle)) !== -1; });
  }

  function cartText(cart) {
    return (cart && cart.items || []).map(lineText).join(" ");
  }

  function groupEligible(group, cart) {
    var ids = cartProductIds(cart);
    if (Array.isArray(group.suppressIfProductInCart) && group.suppressIfProductInCart.some(function (id) { return ids[String(id)]; })) return false;
    return (group.triggerProductIds || []).some(function (id) { return ids[String(id)]; });
  }

  function eligibleGroups(rules, cart) {
    var groups = (rules.offerGroups || []).slice().sort(function (left, right) {
      return Number(right.priority || 0) - Number(left.priority || 0);
    });
    var eligible = groups.filter(function (group) { return !group.defaultFallback && groupEligible(group, cart); });
    if (eligible.length) return eligible;
    var fallback = groups.find(function (group) { return Boolean(group.defaultFallback); });
    return fallback ? [fallback] : [];
  }

  function contextFromLine(line) {
    return { line: line, color: detectColor(line), size: detectSize(line) };
  }

  function resolveNestedVariant(value, color, requireMatched) {
    if (safeInteger(value)) return Number(value);
    if (!isPlainObject(value)) return 0;
    if (color && safeInteger(value[color])) return Number(value[color]);
    if (requireMatched) return 0;
    var first = ownKeys(value).find(function (key) { return safeInteger(value[key]); });
    return first ? Number(value[first]) : 0;
  }

  function resolveVariant(offer, context) {
    context = context || {};
    var color = context.color || "";
    var size = context.size || "";
    var resolved = Number(offer.variantId || 0);
    var matched = false;
    if (!resolved && size && offer.sizeVariantMap && offer.sizeVariantMap[size] !== undefined) {
      resolved = resolveNestedVariant(offer.sizeVariantMap[size], color, Boolean(offer.requireMatchedVariant));
      matched = Boolean(resolved);
    }
    if (!resolved && color && offer.variantMap && safeInteger(offer.variantMap[color])) {
      resolved = Number(offer.variantMap[color]);
      matched = true;
    }
    if (!resolved && Array.isArray(offer.variantChoices) && offer.variantChoices[0]) resolved = Number(offer.variantChoices[0].variantId || 0);
    if (!resolved && offer.targetVariantId) resolved = Number(offer.targetVariantId);
    if (!resolved && offer.fallbackVariantId && !offer.requireMatchedVariant) resolved = Number(offer.fallbackVariantId);
    if (offer.requireMatchedVariant && !matched && (color || size)) return null;
    if (!resolved) return null;
    var image = offer.image || "";
    if (offer.imageVariantMap && offer.imageVariantMap[String(resolved)]) image = offer.imageVariantMap[String(resolved)];
    else if (color && offer.imageMap && offer.imageMap[color]) image = offer.imageMap[color];
    return { variantId: resolved, image: image, color: color, size: size, sourceLine: context.line || null };
  }

  function changeVariantPlan(offer, cart, context) {
    var source = null;
    if (Array.isArray(offer.sourceVariantIds) && offer.sourceVariantIds.length) {
      source = (cart.items || []).find(function (line) { return offer.sourceVariantIds.indexOf(variantId(line)) !== -1; }) || null;
    } else source = context && context.line || null;
    if (!source) return null;
    var quantity = Number(source.quantity || 0);
    if (quantity < Number(offer.minSourceQuantity || 1)) return null;
    if (offer.maxSourceQuantity && quantity > Number(offer.maxSourceQuantity)) return null;
    var target = offer.targetVariantMap && offer.targetVariantMap[String(variantId(source))]
      ? Number(offer.targetVariantMap[String(variantId(source))])
      : Number(offer.targetVariantId || 0);
    if (!target || target === variantId(source)) return null;
    var divisor = Math.max(1, Number(offer.targetQuantityDivisor || 1));
    var targetQuantity = Math.max(1, Math.floor(quantity / divisor));
    return {
      sourceLine: source,
      targetVariantId: target,
      targetQuantity: targetQuantity,
      remainder: Math.max(0, quantity - targetQuantity * divisor)
    };
  }

  function offerSuppressed(offer, cart) {
    var products = cartProductIds(cart);
    if (Array.isArray(offer.requireProductInCart) && !offer.requireProductInCart.some(function (id) { return products[String(id)]; })) return true;
    if (offer.suppressIfProductInCart === true && offer.productId && products[String(offer.productId)]) return true;
    if (Array.isArray(offer.suppressIfProductInCart) && offer.suppressIfProductInCart.some(function (id) { return products[String(id)]; })) return true;
    if (Array.isArray(offer.suppressIfProductIdsPresent) && offer.suppressIfProductIdsPresent.some(function (id) { return products[String(id)]; })) return true;
    if (offer.productId && offer.action !== "change_variant" && products[String(offer.productId)]) return true;
    return Boolean(offer.suppressIfCartContainsText && containsAnyText(cartText(cart), offer.suppressIfCartContainsText));
  }

  function available(prices, wantedVariantId) {
    var entry = prices && prices.prices && prices.prices[String(wantedVariantId)];
    return !entry || entry.available !== false;
  }

  function triggerLines(group, cart) {
    var triggers = group.triggerProductIds || [];
    var lines = (cart.items || []).filter(function (line) { return triggers.indexOf(Number(line.product_id)) !== -1; });
    return lines.length ? lines : (cart.items || []).slice(0, 1);
  }

  function resolveOffer(group, offer, cart, prices) {
    if (offerSuppressed(offer, cart)) return null;
    if (offer.action === "link") return null;
    var lines = triggerLines(group, cart);
    var rawChoices = (offer.perTriggerLineOffer ? lines : lines.slice(0, 1)).map(function (line) {
      var context = contextFromLine(line);
      if (offer.action === "change_variant") {
        var plan = changeVariantPlan(offer, cart, context);
        if (!plan || !available(prices, plan.targetVariantId)) return null;
        return {
          variantId: plan.targetVariantId,
          image: offer.imageVariantMap && offer.imageVariantMap[String(plan.targetVariantId)] || offer.image || "",
          color: context.color,
          size: context.size,
          sourceLine: line,
          upgradePlan: plan
        };
      }
      var resolved = resolveVariant(offer, context);
      if (!resolved || !available(prices, resolved.variantId)) return null;
      return resolved;
    }).filter(Boolean);
    if (!rawChoices.length) return null;
    var choices = [];
    var choiceVariants = Object.create(null);
    rawChoices.forEach(function (choice) {
      var key = String(choice.variantId) + ":" + String(choice.sourceLine && choice.sourceLine.key || choice.sourceLine && variantId(choice.sourceLine) || "");
      if (choiceVariants[key]) return;
      choiceVariants[key] = true;
      choices.push({
        label: [choice.color, choice.size].filter(Boolean).join(" / ") || String(choice.sourceLine && choice.sourceLine.variant_title || "Match cart"),
        variantId: choice.variantId,
        image: choice.image,
        color: choice.color,
        size: choice.size,
        sourceLineKey: choice.sourceLine && choice.sourceLine.key || "",
        sourceVariantId: choice.sourceLine ? variantId(choice.sourceLine) : 0,
        sourceProductId: Number(choice.sourceLine && choice.sourceLine.product_id || 0)
      });
    });
    var selected = rawChoices[0];
    return Object.assign({}, offer, selected, {
      groupId: group.id,
      groupTitle: group.title,
      groupPriority: Number(group.priority || 0),
      contextChoices: choices.length > 1 ? choices : [],
      contextChoiceLabel: offer.variantChoiceLabel || "Match"
    });
  }

  function groupOffers(group, cart, prices) {
    return (group.offers || []).map(function (offer, index) {
      var resolved = resolveOffer(group, offer, cart, prices);
      if (resolved) resolved.rank = index;
      return resolved;
    }).filter(Boolean);
  }

  function interleave(groupRows, maxOffers) {
    var output = [];
    var seenProducts = Object.create(null);
    var seenVariants = Object.create(null);
    var depth = 0;
    var hasMore = true;
    while (hasMore && output.length < maxOffers) {
      hasMore = false;
      for (var groupIndex = 0; groupIndex < groupRows.length && output.length < maxOffers; groupIndex += 1) {
        var row = groupRows[groupIndex];
        var offer = row.offers[depth];
        if (!offer) continue;
        hasMore = true;
        var productKey = offer.productId ? String(offer.productId) : "";
        var variantKey = offer.variantId ? String(offer.variantId) : "";
        if (productKey && seenProducts[productKey] || variantKey && seenVariants[variantKey]) continue;
        if (productKey) seenProducts[productKey] = true;
        if (variantKey) seenVariants[variantKey] = true;
        output.push(offer);
      }
      depth += 1;
    }
    return output;
  }

  function buildRecommendations(rules, cart, prices, options) {
    assertValidRules(rules);
    cart = cart || { items: [] };
    var groups = eligibleGroups(rules, cart);
    var rows = groups.map(function (group) { return { group: group, offers: groupOffers(group, cart, prices) }; });
    var requestedMax = Number(options && options.maxOffers || rules.cart && rules.cart.maxOffers || 12);
    var maxOffers = Math.max(1, Math.min(20, requestedMax));
    return {
      groups: groups,
      offers: interleave(rows, maxOffers),
      byGroup: rows,
      fallback: Boolean(groups[0] && groups[0].defaultFallback),
      engineVersion: VERSION,
      rulesVersion: rules.version
    };
  }

  return Object.freeze({
    VERSION: VERSION,
    CHECKOUT_PATH: CHECKOUT_PATH,
    validateRules: validateRules,
    assertValidRules: assertValidRules,
    hardenRuntimeConfig: hardenRuntimeConfig,
    detectColor: detectColor,
    detectSize: detectSize,
    eligibleGroups: eligibleGroups,
    resolveVariant: resolveVariant,
    buildRecommendations: buildRecommendations,
    sameOriginPath: sameOriginPath,
    safeReadAssetUrl: safeReadAssetUrl,
    safeDisplayImageUrl: safeDisplayImageUrl
  });
});
